import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, FormControl, FormHelperText, OutlinedInput } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { postUserResetEmail } from '../../utilities/api';

type Props = {
    onFormChange: (nextForm: 'sent' | 'login') => void;
};

export const ForgotForm = ({ onFormChange }: Props) => {
    const userResetEmailMutation = useMutation({ mutationFn: postUserResetEmail });
    const initialValues = { email: '' };
    const validationSchema = yup.object().shape({
        email: yup.string().email('Invalid email').required('Required'),
    });

    const handleFormSubmit = async (values: typeof initialValues) => {
        userResetEmailMutation.mutate(values, {
            onSuccess: () => {
                onFormChange('sent');
            },
            onError: () => {
                onFormChange('login');
            },
        });
    };

    const handleFormChange = () => {
        onFormChange('login');
    };

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleFormSubmit}>
            {({ values, errors, handleChange, handleBlur, touched, isSubmitting }) => (
                <Form noValidate autoComplete="off">
                    <Button variant="text" startIcon={<ArrowBack />} onClick={handleFormChange}>
                        Login
                    </Button>
                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }} error={Boolean(errors.email && touched.email)}>
                        <OutlinedInput
                            aria-describedby="email-text"
                            placeholder="Email"
                            type="email"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                        />
                        {errors.email && touched.email && <FormHelperText id="email-text">{errors.email}</FormHelperText>}
                    </FormControl>
                    <Button disabled={isSubmitting} type="submit" size="large" sx={{ mt: 2, mb: 2 }} fullWidth variant="contained">
                        Send Password Reset
                    </Button>
                </Form>
            )}
        </Formik>
    );
};
